"use client";

import type { LomdaScene } from "@/features/lomdaEditorV2/lib/lomdaTypes";
import type { SceneElement } from "@/features/lomdaEditorV2/lib/elements/types";
import { TextElementView } from "./TextElementView";
import { MediaElementView } from "./MediaElementView";
import { AvatarElementView } from "./AvatarElementView";

export function ElementView({
    scene,
    element,
    isEditing,
}: {
    scene: LomdaScene;
    element: SceneElement;
    isEditing: boolean;
}) {
    switch (element.kind) {
        case "text":
            return (
                <TextElementView
                    scene={scene}
                    element={element}
                    isEditing={isEditing}
                />
            );
        case "media":
            return <MediaElementView element={element} />;
        case "avatar":
            return <AvatarElementView element={element} />;
    }
}
